import { Link, Menu, MenuItem, Tooltip } from '@mui/material';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import { SnackBarTypes } from '../../store/snackbarReducer';
import useShowSnackbar from '../../hooks/useShowSnackbar';
import { useCallback, useMemo } from 'react';
import useAuth from '../../hooks/useAuth';
import { MeetingProvidersType } from '../../models/ICompany';
import { bindMenu, bindTrigger, usePopupState } from 'material-ui-popup-state/hooks';
import CommonHeaderBtn from '../CommonHeaderBtn';

const buttonSx = { '& > svg': { fill: 'currentColor' }, alignSelf: 'center' };

const CopyVideoLink = () => {
    const { showSnackbar } = useShowSnackbar();
    const { user } = useAuth();

    const popupState = usePopupState({
        variant: 'popover',
        popupId: 'zoom_call_actions'
    });

    const host = window.location.origin;

    const chatLink = useMemo(() => {
        const companySlug = user?.currentCompany.slug;
        const employeeSlug = user?.employee.slug;

        return `${host}/cal/${companySlug}/${employeeSlug}/cbvc`;
    }, [user, host]);

    const handleCopy = useCallback(() => {
        navigator.clipboard.writeText(chatLink).then(() => {
            showSnackbar({ alertSeverity: SnackBarTypes.Success, message: 'Link copied to clipboard!' });
        });
    }, [chatLink, showSnackbar]);

    const meetingsProvider = user?.currentCompany.settings?.integrations.meetings;
    const ariaLabel = useMemo(() => {
        if (meetingsProvider === MeetingProvidersType.Whereby) {
            return 'Copy video chat link';
        }

        if (meetingsProvider === MeetingProvidersType.Zoom) {
            return 'Video Call Menu';
        }

        return undefined;
    }, [meetingsProvider]);

    if (meetingsProvider === MeetingProvidersType.Whereby) {
        return (
            <Tooltip arrow title={<>{ariaLabel}</>}>
                <span>
                    <CommonHeaderBtn disabled={!user} aria-label={ariaLabel} onClick={handleCopy} sx={buttonSx}>
                        <VideocamOutlinedIcon />
                    </CommonHeaderBtn>
                </span>
            </Tooltip>
        );
    }

    if (meetingsProvider === MeetingProvidersType.Zoom) {
        return (
            <>
                <Tooltip arrow title={<>{ariaLabel}</>}>
                    <span>
                        <CommonHeaderBtn disabled={!user} aria-label={ariaLabel} {...bindTrigger(popupState)} sx={buttonSx}>
                            <VideocamOutlinedIcon />
                        </CommonHeaderBtn>
                    </span>
                </Tooltip>
                <Menu {...bindMenu(popupState)} aria-label="Video Call Menu">
                    <MenuItem
                        component={Link}
                        href={`${host}/profile/cbvc`}
                        target="_blank"
                        onClick={() => {
                            popupState.close();
                        }}
                    >
                        Start Meeting as Host
                    </MenuItem>
                    <MenuItem
                        onClick={() => {
                            handleCopy();
                            popupState.close();
                        }}
                    >
                        Copy Link to Meeting
                    </MenuItem>
                </Menu>
            </>
        );
    }

    return null;
};

export default CopyVideoLink;
